// menubar

$(".navbar-toggler").click(function () {
    $(".navbar-collapse").toggleClass("menu-visible");
    $(".menu_overlay").toggleClass("menu-visible");
    $("body").css("overflow", "hidden");
});

$(".menu_close_btn").click(function () {
    $(".navbar-collapse").removeClass("menu-visible");
    $(".navbar-collapse").removeClass("show");
    $(".menu_overlay").removeClass("menu-visible");
    $("body").css("overflow", "auto");
});

$(".menu_overlay").click(function () {
    $(".menu_overlay").removeClass("menu-visible");
    $(".navbar-collapse").removeClass("show");
    $(".navbar-collapse").removeClass("menu-visible");
    $("body").css("overflow", "auto");
});

$(".web-header .navbar .navbar-nav li ul").find("li").closest("ul").parent("li").addClass('dropdown_menu');
$(".web-header .navbar .navbar-nav li").click(function () {
    $(this).toggleClass("curent");
    $('.web-header .navbar .navbar-nav li').not($(this)).removeClass('curent');
});

/* bkp26.10.26 */
// Add dropdown_menu helper class
$(".web-header .navbar .navbar-nav li ul").find("li").closest("ul").parent("li").addClass("dropdown_menu");

// Setup clickD dropdown toggles for touch / mobile devices (<= 991px)
function setupMobileMenuClickD() {
    if ($(window).width() <= 991) {
        $('.web-header-bottom .navbar-nav > li').each(function () {
            var $li = $(this);
            // If item has a submenu or megamenu and doesn't already have clickD
            if (($li.find('> .sub-menu').length || $li.hasClass('megamenu-item') || $li.hasClass('dropdown_menu')) && !$li.find('> .clickD').length) {
                $li.find('> a').after('<span class="clickD"><i class="fa-solid fa-angle-down"></i></span>');
            }
        });
    } else {
        $('.web-header-bottom .navbar-nav > li > .clickD').remove();
        $('.web-header-bottom .navbar-nav > li').removeClass('curent');
    }
}

$(document).ready(function () {
    setupMobileMenuClickD();
});

$(window).on('resize', function () {
    setupMobileMenuClickD();
});

// Toggle sub-menu only when clickD arrow button is tapped, leaving anchor link clickable
$(document).on('click', '.web-header-bottom .navbar-nav > li > .clickD', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);
    var $parentLi = $this.closest('li');

    // Toggle current item
    $parentLi.toggleClass('curent');
    $this.toggleClass('toggled');

    // Close any other open sub-menus & untoggle their clickD buttons
    $('.web-header-bottom .navbar-nav > li').not($parentLi).removeClass('curent');
    $('.web-header-bottom .navbar-nav > li > .clickD').not($this).removeClass('toggled');
});
/* bkp26.10.26_end */

// best seller js
$(function () {
    var owl = $(".best-seller-wrapper");

    owl.owlCarousel({
        items: 5,
        loop: true,
        nav: true,
        dots: false,
        autoplay: false,
        margin: 30,
        slideSpeed: 1000,

        // Custom arrows
        navText: [
            '<span class="custom-prev-arrow"><i class="fa-solid fa-arrow-left"></i></span>',
            '<span class="custom-next-arrow"><i class="fa-solid fa-arrow-right"></i></span>'
        ],

        responsive: {
            0: {
                items: 1
            },
            575: {
                items: 1,
                slideSpeed: 1000
            },
            767: {
                items: 2
            },
            991: {
                items: 3
            },
            1024: {
                items: 3,
                slideSpeed: 1000
            }
        }
    });
});

// steel js
$(function () {
    var owl = $(".steel-wrapper");

    owl.owlCarousel({
        items: 5,
        loop: true,
        nav: true,
        dots: false,
        autoplay: false,
        margin: 30,
        slideSpeed: 1000,

        // Custom arrows
        navText: [
            '<span class="custom-prev-arrow"><i class="fa-solid fa-arrow-left"></i></span>',
            '<span class="custom-next-arrow"><i class="fa-solid fa-arrow-right"></i></span>'
        ],

        responsive: {
            0: {
                items: 1
            },
            575: {
                items: 2,
                slideSpeed: 1000
            },
            767: {
                items: 3
            },
            991: {
                items: 3
            },
            1024: {
                items: 4,
                slideSpeed: 1000
            }
        }
    });
});

// testimonials js
$(function () {
    var owl = $(".testimonials-wrapper");

    owl.owlCarousel({
        items: 5,
        loop: true,
        nav: true,
        dots: false,
        autoplay: false,
        margin: 30,
        slideSpeed: 1000,

        // Custom arrows
        navText: [
            '<span class="custom-prev-arrow"><i class="fa-solid fa-angle-left"></i></span>',
            '<span class="custom-next-arrow"><i class="fa-solid fa-angle-right"></i></span>'
        ],

        responsive: {
            0: {
                items: 1,
                nav: false
            },
            575: {
                items: 2,
                slideSpeed: 1000,
                nav: false
            },
            767: {
                items: 3,
                nav: false
            },
            1200: {
                items: 3,
                nav: true
            },
            1024: {
                items: 3,
                slideSpeed: 1000
            }
        }
    });
});

// search toggle

$(document).ready(function () {
    $('.mobile-search-btn').on('click', function () {
        $('.web-header-top-right').slideToggle();
    });
});

// filter js

document.addEventListener("DOMContentLoaded", function () {

    // Main elements
    const sidebar = document.querySelector(".filter-right-bar");
    if (!sidebar) return;
    const openBtn = document.getElementById("openFilterBtn");

    // Both .filter-top sections
    const filterTops = sidebar.querySelectorAll(".filter-top");

    // First button = sidebar close
    const closeBtn = filterTops[0].querySelector(".close");

    // Second button = advanced filter toggle
    const advancedToggleBtn = filterTops[1].querySelector(".close");

    // Both filter sections
    const filterSections = sidebar.querySelectorAll(".filter-form-box-outer");

    // Second filter section = advanced filters
    const advancedSection = filterSections[1];

    // Optional overlay
    let overlay = document.querySelector(".filter-overlay");


    // Create overlay automatically if it doesn't exist
    if (!overlay) {
        overlay = document.createElement("div");
        overlay.classList.add("filter-overlay");
        document.body.appendChild(overlay);
    }


    /* ===============================
       OPEN SIDEBAR
    =============================== */

    function openSidebar() {
        sidebar.classList.add("active");
        overlay.classList.add("active");
        document.body.classList.add("filter-open");
    }


    /* ===============================
       CLOSE SIDEBAR
    =============================== */

    function closeSidebar() {
        sidebar.classList.remove("active");
        overlay.classList.remove("active");
        document.body.classList.remove("filter-open");
    }


    /* Open sidebar */

    if (openBtn) {
        openBtn.addEventListener("click", function (e) {
            e.preventDefault();
            openSidebar();
        });
    }


    /* Close sidebar */

    if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
            e.preventDefault();
            closeSidebar();
        });
    }


    /* Overlay click */

    overlay.addEventListener("click", function () {
        closeSidebar();
    });


    /* ESC button */

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeSidebar();
        }
    });


    /* ===============================
       ADVANCED FILTER TOGGLE
    =============================== */

    if (advancedToggleBtn && advancedSection) {

        advancedToggleBtn.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            const icon = advancedToggleBtn.querySelector("i");

            // Check current state
            const isHidden = advancedSection.style.display === "none";

            if (isHidden) {

                // OPEN
                advancedSection.style.display = "block";

                if (icon) {
                    icon.classList.remove("fa-angle-down");
                    icon.classList.add("fa-angle-up");
                }

            } else {

                // CLOSE
                advancedSection.style.display = "none";

                if (icon) {
                    icon.classList.remove("fa-angle-up");
                    icon.classList.add("fa-angle-down");
                }
            }

        });
    }

});

// side bar toggle js

document.addEventListener("DOMContentLoaded", function () {

    const advancedToggle = document.getElementById("advancedToggle");
    const advancedContent = document.getElementById("advancedFilterContent");
    if (!advancedToggle || !advancedContent) return;
    const toggleIcon = advancedToggle.querySelector("i");

    advancedToggle.addEventListener("click", function (e) {
        e.preventDefault();

        if (advancedContent.classList.contains("advanced-hidden")) {

            // Open advanced filter
            advancedContent.classList.remove("advanced-hidden");

            toggleIcon.classList.remove("fa-angle-down");
            toggleIcon.classList.add("fa-angle-up");

        } else {

            // Close advanced filter
            advancedContent.classList.add("advanced-hidden");

            toggleIcon.classList.remove("fa-angle-up");
            toggleIcon.classList.add("fa-angle-down");
        }
    });

});

// read more js for category content
function initCategoryReadMore() {
    const infoInners = document.querySelectorAll(".feetguard-info-inner");
    if (!infoInners.length) return;

    infoInners.forEach(function (inner) {
        const infoSection = inner.querySelector(".feetguard-info-wrapper");
        const moreInfoBtn = inner.querySelector(".feetguard-more-btn, .secoundary-btn");

        if (!infoSection || !moreInfoBtn) return;

        const maxHeight = parseInt(infoSection.dataset.maxHeight || "450", 10);

        function checkHeight() {
            // Check if content exceeds maximum height (with 25px buffer)
            if (infoSection.scrollHeight > maxHeight + 25) {
                infoSection.classList.add("is-collapsible");
                if (!infoSection.classList.contains("show-more")) {
                    infoSection.style.maxHeight = maxHeight + "px";
                    moreInfoBtn.style.display = "inline-flex";
                    moreInfoBtn.innerHTML = moreInfoBtn.dataset.moreText || "CLICK HERE FOR MORE INFO";
                }
            } else {
                // Content is short: remove collapsible state and hide the button completely
                infoSection.classList.remove("is-collapsible");
                infoSection.classList.remove("show-more");
                infoSection.style.maxHeight = "none";
                moreInfoBtn.style.display = "none";
            }
        }

        // Run check initially
        checkHeight();

        // Also check when any images inside finish loading
        const images = infoSection.querySelectorAll("img");
        images.forEach(function (img) {
            if (img.complete) {
                checkHeight();
            } else {
                img.addEventListener("load", checkHeight, { once: true });
            }
        });

        // Click handler (avoid duplicate listeners)
        if (!moreInfoBtn.dataset.listenerAttached) {
            moreInfoBtn.dataset.listenerAttached = "true";
            moreInfoBtn.addEventListener("click", function (e) {
                e.preventDefault();

                const isExpanded = infoSection.classList.toggle("show-more");

                if (isExpanded) {
                    infoSection.style.maxHeight = infoSection.scrollHeight + "px";
                    moreInfoBtn.innerHTML = moreInfoBtn.dataset.lessText || "CLICK HERE FOR LESS INFO";

                    setTimeout(function () {
                        if (infoSection.classList.contains("show-more")) {
                            infoSection.style.maxHeight = "none";
                        }
                    }, 400);
                } else {
                    infoSection.style.maxHeight = infoSection.scrollHeight + "px";
                    infoSection.offsetHeight; // Force reflow
                    infoSection.style.maxHeight = maxHeight + "px";
                    moreInfoBtn.innerHTML = moreInfoBtn.dataset.moreText || "CLICK HERE FOR MORE INFO";

                    const rect = infoSection.getBoundingClientRect();
                    if (rect.top < 0) {
                        window.scrollTo({
                            top: window.pageYOffset + rect.top - 100,
                            behavior: "smooth"
                        });
                    }
                }
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", initCategoryReadMore);
window.addEventListener("load", initCategoryReadMore);

// fixed header 

$(window).scroll(function () {
    if ($(window).scrollTop() >= 50) {
        $('.web-header').addClass('fixed-header');
        $('nav div').addClass('visible-title');
    }
    else {
        $('.web-header').removeClass('fixed-header');
        $('nav div').removeClass('visible-title');
    }
});

// mobile filter btn sec

document.addEventListener("DOMContentLoaded", function () {

    // Main elements
    const sidebar = document.querySelector(".mobile-filter-right-bar");
    if (!sidebar) return;
    const openBtn = document.getElementById("mobileopenFilterBtn");

    // Both .filter-top sections
    const filterTops = sidebar.querySelectorAll(".filter-top");

    // First button = sidebar close
    const closeBtn = filterTops[0].querySelector(".close");

    // Second button = advanced filter toggle
    const advancedToggleBtn = filterTops[1].querySelector(".close");

    // Both filter sections
    const filterSections = sidebar.querySelectorAll(".filter-form-box-outer");

    // Second filter section = advanced filters
    const advancedSection = filterSections[1];

    // Optional overlay
    let overlay = document.querySelector(".filter-overlay");


    // Create overlay automatically if it doesn't exist
    if (!overlay) {
        overlay = document.createElement("div");
        overlay.classList.add("filter-overlay");
        document.body.appendChild(overlay);
    }


    /* ===============================
       OPEN SIDEBAR
    =============================== */

    function openSidebar() {
        sidebar.classList.add("active");
        overlay.classList.add("active");
        document.body.classList.add("filter-open");
    }


    /* ===============================
       CLOSE SIDEBAR
    =============================== */

    function closeSidebar() {
        sidebar.classList.remove("active");
        overlay.classList.remove("active");
        document.body.classList.remove("filter-open");
    }


    /* Open sidebar */

    if (openBtn) {
        openBtn.addEventListener("click", function (e) {
            e.preventDefault();
            openSidebar();
        });
    }


    /* Close sidebar */

    if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
            e.preventDefault();
            closeSidebar();
        });
    }


    /* Overlay click */

    overlay.addEventListener("click", function () {
        closeSidebar();
    });


    /* ESC button */

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closeSidebar();
        }
    });


    /* ===============================
       ADVANCED FILTER TOGGLE
    =============================== */

    if (advancedToggleBtn && advancedSection) {

        advancedToggleBtn.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            const icon = advancedToggleBtn.querySelector("i");

            // Check current state
            const isHidden = advancedSection.style.display === "none";

            if (isHidden) {

                // OPEN
                advancedSection.style.display = "block";

                if (icon) {
                    icon.classList.remove("fa-angle-down");
                    icon.classList.add("fa-angle-up");
                }

            } else {

                // CLOSE
                advancedSection.style.display = "none";

                if (icon) {
                    icon.classList.remove("fa-angle-up");
                    icon.classList.add("fa-angle-down");
                }
            }

        });
    }

});

// Search sidebar filter handlers
document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const qVal = urlParams.get('q') || '';

    const filterFields = ['year', 'make', 'model', 'engine', 'micron_rating', 'lube_rating'];

    // Pre-populate selects and clean search inputs
    let cleanQ = qVal;
    filterFields.forEach(field => {
        const regex = new RegExp('tag:' + field + '_([^\\s]+)');
        const match = qVal.match(regex);
        if (match) {
            const val = match[1];
            document.querySelectorAll(`select[name="${field}"]`).forEach(select => {
                select.value = val;
            });

            // If an advanced filter field is active, expand the advanced filter accordion
            if (['micron_rating', 'lube_rating'].includes(field)) {
                document.querySelectorAll('.advanced-filter-content').forEach(adv => {
                    adv.style.display = 'block';
                });
                document.querySelectorAll('.advanced-toggle i').forEach(icon => {
                    icon.classList.remove('fa-angle-down');
                    icon.classList.add('fa-angle-up');
                });
            }

            // Clean this tag from the search query shown to users
            cleanQ = cleanQ.replace(new RegExp('\\s*tag:' + field + '_[^\\s]+', 'g'), '');
        }
    });
    cleanQ = cleanQ.trim();

    if (qVal !== cleanQ) {
        document.querySelectorAll('input[name="q"]').forEach(input => {
            input.value = cleanQ;
        });
    }

    // Intercept form submissions to append selected tags
    document.querySelectorAll('form[action="/search"]').forEach(form => {
        form.addEventListener('submit', function (e) {
            // Find active sidebar
            const activeSidebar = document.querySelector('.filter-right-bar.active') || document.body;
            const qInput = form.querySelector('input[name="q"]');
            if (qInput) {
                let val = qInput.value.trim();
                // Clean existing tags
                filterFields.forEach(field => {
                    val = val.replace(new RegExp('\\s*tag:' + field + '_[^\\s]+', 'g'), '');
                });
                val = val.trim();

                // Append new tags
                filterFields.forEach(field => {
                    const select = activeSidebar.querySelector(`select[name="${field}"]`);
                    if (select && select.value) {
                        val = (val ? val + ' ' : '') + `tag:${field}_` + select.value;
                    }
                });
                qInput.value = val;
            }
        });
    });

    // Handle sidebar Apply and Reset button actions
    document.querySelectorAll('.filter-right-bar').forEach(sidebar => {
        const applyBtn = sidebar.querySelector('.apply-btn');
        const resetBtn = sidebar.querySelector('.reset-btn');

        if (applyBtn) {
            applyBtn.addEventListener('click', function () {
                const params = new URLSearchParams(window.location.search);
                let currentQ = '';

                // Get active visible search query
                const activeSearchInput = document.querySelector('input[name="q"]');
                if (activeSearchInput) {
                    currentQ = activeSearchInput.value;
                } else {
                    currentQ = params.get('q') || '';
                }

                // Clean existing tags
                filterFields.forEach(field => {
                    currentQ = currentQ.replace(new RegExp('\\s*tag:' + field + '_[^\\s]+', 'g'), '');
                });
                currentQ = currentQ.trim();

                // Append selected tags
                filterFields.forEach(field => {
                    const select = sidebar.querySelector(`select[name="${field}"]`);
                    if (select && select.value) {
                        currentQ = (currentQ ? currentQ + ' ' : '') + `tag:${field}_` + select.value;
                    }
                });

                params.set('q', currentQ);
                params.set('type', 'product');
                window.location.href = '/search?' + params.toString();
            });
        }

        if (resetBtn) {
            resetBtn.addEventListener('click', function () {
                filterFields.forEach(field => {
                    const select = sidebar.querySelector(`select[name="${field}"]`);
                    if (select) select.value = '';
                });

                const params = new URLSearchParams(window.location.search);
                let currentQ = params.get('q') || '';
                filterFields.forEach(field => {
                    currentQ = currentQ.replace(new RegExp('\\s*tag:' + field + '_[^\\s]+', 'g'), '');
                });
                currentQ = currentQ.trim();

                if (currentQ) {
                    params.set('q', currentQ);
                } else {
                    params.delete('q');
                }
                window.location.href = '/search?' + params.toString();
            });
        }
    });
});

/* 15.9.26 start */
$(document).ready(function () {
    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 4;
    var syncedSecondary = true;

    if (sync1.length && sync2.length) {
        sync1.owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: false,
            autoplay: false,
            dots: false,
            loop: false,
            responsiveRefreshRate: 200,
            margin: 10
        }).on('changed.owl.carousel', syncPosition);

        sync2.on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
        }).owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            margin: 20,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: slidesPerPage,
            responsiveRefreshRate: 100,
            responsive: {
                0: { items: 4, margin: 10 },
                575: { items: 5, margin: 15 },
                767: { items: 6, margin: 20 }
            }
        }).on('changed.owl.carousel', syncPosition2);

        function syncPosition(el) {
            var count = el.item.count - 1;
            var current = Math.round(el.item.index);

            if (current < 0) { current = 0; }
            if (current > count) { current = count; }

            sync2
                .find(".owl-item")
                .removeClass("current")
                .find(".thumb-box")
                .removeClass("active");

            sync2
                .find(".owl-item")
                .eq(current)
                .addClass("current")
                .find(".thumb-box")
                .addClass("active");

            var onscreen = sync2.find('.owl-item.active').length;
            var start = sync2.find('.owl-item.active').first().index();
            var end = sync2.find('.owl-item.active').last().index();

            if (current > end) {
                sync2.data('owl.carousel').to(current, 100, true);
            }
            if (current < start) {
                sync2.data('owl.carousel').to(current - onscreen + 1, 100, true);
            }
        }

        function syncPosition2(el) {
            if (syncedSecondary) {
                var number = el.item.index;
                sync1.data('owl.carousel').to(number, 100, true);
            }
        }

        sync2.on("click", ".owl-item", function (e) {
            e.preventDefault();
            var number = $(this).index();
            sync1.data('owl.carousel').to(number, 300, true);
        });
    }

    // Pairs Well With Carousel
    var pairsCarousel = $("#pairsWellCarousel");
    if (pairsCarousel.length) {
        pairsCarousel.owlCarousel({
            items: 4,
            margin: 30,
            dots: false,
            nav: true,
            navText: [
                '<svg class="nav-arrow-icon" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.132191 4.68115L4.67754 0.158108C4.84082 -0.0316151 5.12776 -0.0537319 5.31843 0.108783C5.50909 0.271258 5.53131 0.556796 5.368 0.746519C5.35276 0.764205 5.3362 0.780724 5.31843 0.795845L1.55033 4.54997H14.5455C14.7965 4.54997 15 4.75248 15 5.00229C15 5.25211 14.7965 5.45458 14.5455 5.45458H1.55033L5.31843 9.20415C5.50909 9.36663 5.53131 9.65217 5.368 9.84189C5.20468 10.0316 4.91777 10.0537 4.72711 9.89122C4.70934 9.87606 4.69273 9.85958 4.67754 9.84189L0.132151 5.31885C-0.0440569 5.1425 -0.0440559 4.85758 0.132191 4.68115Z" fill="#06205B"/></svg>',
                '<svg class="nav-arrow-icon" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8678 4.68115L10.3225 0.158108C10.1592 -0.0316151 9.87224 -0.0537319 9.68157 0.108783C9.49091 0.271258 9.46869 0.556796 9.632 0.746519C9.64724 0.764205 9.6638 0.780724 9.68157 0.795845L13.4497 4.54997H0.454545C0.203526 4.54997 0 4.75248 0 5.00229C0 5.25211 0.203526 5.45458 0.454545 5.45458H13.4497L9.68157 9.20415C9.49091 9.36663 9.46869 9.65217 9.632 9.84189C9.79532 10.0316 10.0822 10.0537 10.2729 9.89122C10.2907 9.87606 10.3073 9.85958 10.3225 9.84189L14.8678 5.31885C15.0441 5.1425 15.0441 4.85758 14.8678 4.68115Z" fill="#06205B"/></svg>'
            ],
            loop: false,
            responsiveRefreshRate: 200,
            responsive: {
                0: { items: 1, margin: 15 },
                575: { items: 2, margin: 15 },
                767: { items: 3, margin: 20 },
                992: { items: 4, margin: 30 }
            }
        });
    }

    // You May Also Like Carousel
    var alsoLikeCarousel = $("#alsoLikeCarousel");
    if (alsoLikeCarousel.length) {
        alsoLikeCarousel.owlCarousel({
            items: 4,
            margin: 30,
            dots: false,
            nav: true,
            navText: [
                '<svg class="nav-arrow-icon" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.132191 4.68115L4.67754 0.158108C4.84082 -0.0316151 5.12776 -0.0537319 5.31843 0.108783C5.50909 0.271258 5.53131 0.556796 5.368 0.746519C5.35276 0.764205 5.3362 0.780724 5.31843 0.795845L1.55033 4.54997H14.5455C14.7965 4.54997 15 4.75248 15 5.00229C15 5.25211 14.7965 5.45458 14.5455 5.45458H1.55033L5.31843 9.20415C5.50909 9.36663 5.53131 9.65217 5.368 9.84189C5.20468 10.0316 4.91777 10.0537 4.72711 9.89122C4.70934 9.87606 4.69273 9.85958 4.67754 9.84189L0.132151 5.31885C-0.0440569 5.1425 -0.0440559 4.85758 0.132191 4.68115Z" fill="#06205B"/></svg>',
                '<svg class="nav-arrow-icon" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8678 4.68115L10.3225 0.158108C10.1592 -0.0316151 9.87224 -0.0537319 9.68157 0.108783C9.49091 0.271258 9.46869 0.556796 9.632 0.746519C9.64724 0.764205 9.6638 0.780724 9.68157 0.795845L13.4497 4.54997H0.454545C0.203526 4.54997 0 4.75248 0 5.00229C0 5.25211 0.203526 5.45458 0.454545 5.45458H13.4497L9.68157 9.20415C9.49091 9.36663 9.46869 9.65217 9.632 9.84189C9.79532 10.0316 10.0822 10.0537 10.2729 9.89122C10.2907 9.87606 10.3073 9.85958 10.3225 9.84189L14.8678 5.31885C15.0441 5.1425 15.0441 4.85758 14.8678 4.68115Z" fill="#06205B"/></svg>'
            ],
            loop: false,
            responsiveRefreshRate: 200,
            responsive: {
                0: { items: 1, margin: 15 },
                575: { items: 2, margin: 15 },
                767: { items: 3, margin: 20 },
                992: { items: 4, margin: 30 }
            }
        });
    }

    // Quantity Controls
    $(document).on('click', '#qtyMinus, .qty-minus', function () {
        var $input = $(this).closest('.qty-control-pill').find('.qty-input');
        if (!$input.length) $input = $('#qtyInput');
        var val = parseInt($input.val(), 10) || 1;
        if (val > 1) {
            $input.val(val - 1).trigger('change');
        }
    });

    $(document).on('click', '#qtyPlus, .qty-plus', function () {
        var $input = $(this).closest('.qty-control-pill').find('.qty-input');
        if (!$input.length) $input = $('#qtyInput');
        var val = parseInt($input.val(), 10) || 1;
        $input.val(val + 1).trigger('change');
    });

    // Product Accordion Toggle
    $(document).on('click', '.product-accordion-item:not(.product-link-item) .accordion-header', function (e) {
        if ($(e.target).closest('.accordion-read-more-btn').length) {
            return;
        }
        var $item = $(this).closest('.product-accordion-item');
        var $body = $item.find('.accordion-body');
        if (!$body.length) return;

        if ($item.hasClass('active')) {
            $item.removeClass('active');
            $body.slideUp(300);
        } else {
            $('.product-accordion-item').removeClass('active').find('.accordion-body').slideUp(300);
            $item.addClass('active');
            $body.slideDown(300);
        }
    });

    // Helper: Validate custom-made product options & terms agreement
    function validateCustomProductState($form, variant) {
        if (!$form || !$form.length) $form = $('#product-form');
        var $termsCheckbox = $form.find('#customTermsCheckbox');
        var $addBtn = $form.find('.add-to-cart-btn');
        var $btnText = $addBtn.find('.btn-text');
        var $arrowIcon = $addBtn.find('.btn-arrow-icon');
        var $qtyPill = $form.find('.qty-control-pill');
        var $qtyInputs = $qtyPill.find('.qty-btn, .qty-input');

        var isTermsChecked = $termsCheckbox.length ? $termsCheckbox.is(':checked') : true;

        // Check required Hulk Options dropdowns or inputs
        var allOptionsFilled = true;
        var $hulkSelects = $form.find('.hulkapps-custom-options select[required], .hulkapps_option select[required], select.hulkapps_option_child[required]');
        if ($hulkSelects.length) {
            $hulkSelects.each(function () {
                var val = $(this).val();
                if (!val || val === "" || String(val).indexOf('CHOOSE') === 0) {
                    allOptionsFilled = false;
                    return false;
                }
            });
        }

        // Check variant availability
        var isAvailable = true;
        if (typeof variant !== 'undefined' && variant !== null) {
            isAvailable = variant.available;
        } else {
            if ($addBtn.hasClass('is-sold-out')) isAvailable = false;
        }

        if (!isAvailable) {
            $addBtn.prop('disabled', true).addClass('disabled btn-choose-options');
            $qtyPill.addClass('disabled');
            $qtyInputs.prop('disabled', true);
            if ($btnText.length) $btnText.text('SOLD OUT');
            $arrowIcon.hide();
            return;
        }

        if (isTermsChecked && allOptionsFilled) {
            // Activate ADD TO CART
            $addBtn.prop('disabled', false).removeClass('btn-choose-options disabled');
            $qtyPill.removeClass('disabled');
            $qtyInputs.prop('disabled', false);
            if ($btnText.length) $btnText.text('ADD TO CART');
            $arrowIcon.show();
        } else {
            // Revert to disabled CHOOSE OPTIONS
            $addBtn.prop('disabled', true).addClass('btn-choose-options disabled');
            $qtyPill.addClass('disabled');
            $qtyInputs.prop('disabled', true);
            if ($btnText.length) $btnText.text('CHOOSE OPTIONS');
            $arrowIcon.hide();
        }
    }

    // Helper to update product UI & Slider on Variant Change
    function updateProductUI($form, variant) {
        if (!variant) return;

        // Update price
        if ($('.product-price-sec .current-price').length) {
            $('.product-price-sec .current-price').text('$' + (variant.price / 100).toFixed(2));
        }
        if (variant.compare_at_price > variant.price) {
            var oldPriceText = '$' + (variant.compare_at_price / 100).toFixed(2);
            if ($('.product-price-sec .old-price').length) {
                $('.product-price-sec .old-price').text(oldPriceText).show();
            } else {
                $('.product-price-sec').append('<del class="old-price">' + oldPriceText + '</del>');
            }
        } else {
            $('.product-price-sec .old-price').hide();
        }

        // Update SKU
        if (variant.sku && $('.brand-sku-box .sku-value').length) {
            $('.brand-sku-box .sku-value').text(variant.sku);
        }

        // Update Add to Cart Button state & Quantity Controls
        var $addBtn = $form.find('.add-to-cart-btn');
        var $qtyPill = $form.find('.qty-control-pill');
        var $qtyInputs = $qtyPill.find('.qty-btn, .qty-input');
        var isCustomProduct = $form.hasClass('is-custom-made') || $form.data('is-custom-made') === true || $form.find('#customTermsWrap').is(':visible');

        if (isCustomProduct) {
            validateCustomProductState($form, variant);
            if (variant.available) {
                $('.product-badge.badge-in-stock').show();
            } else {
                $('.product-badge.badge-in-stock').hide();
            }
        } else {
            if (variant.available) {
                $addBtn.prop('disabled', false).removeClass('disabled btn-choose-options');
                $qtyPill.removeClass('disabled');
                $qtyInputs.prop('disabled', false);
                if ($addBtn.find('.btn-text').length) {
                    $addBtn.find('.btn-text').text('ADD TO CART');
                } else {
                    $addBtn.contents().filter(function () { return this.nodeType === 3; }).first().replaceWith('ADD TO CART ');
                }
                $addBtn.find('.btn-arrow-icon').show();
                $('.product-badge.badge-in-stock').show();
            } else {
                $addBtn.prop('disabled', true).addClass('disabled');
                $qtyPill.addClass('disabled');
                $qtyInputs.prop('disabled', true);
                if ($addBtn.find('.btn-text').length) {
                    $addBtn.find('.btn-text').text('SOLD OUT');
                } else {
                    $addBtn.contents().filter(function () { return this.nodeType === 3; }).first().replaceWith('SOLD OUT ');
                }
                $addBtn.find('.btn-arrow-icon').hide();
                $('.product-badge.badge-in-stock').hide();
            }
        }

        // Sync and auto-select product image in slider
        var mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
        if (mediaId && $('#sync1').length) {
            var $matchingSlide = $('#sync1 .product-main-img-box[data-media-id="' + mediaId + '"]');
            if ($matchingSlide.length) {
                var slideIndex = $('#sync1 .product-main-img-box').index($matchingSlide);
                if (slideIndex >= 0) {
                    $('#sync1').trigger('to.owl.carousel', [slideIndex, 300]);
                }
            }
        }

        // Update URL query string
        if (window.history && window.history.replaceState) {
            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }

    // Smart Variant Availability & Option Pill Handler
    function updateVariantAvailability($form, variants) {
        var $groups = $form.find('.variant-option-group');
        if (!$groups.length || !variants || !variants.length) return;

        // 1. Get currently selected Option 1
        var selectedOpt1 = $groups.eq(0).find('.variant-pill-input:checked').val();

        // 2. Find all variants that match Option 1
        var matchingVariants = variants.filter(function (v) {
            return v.options[0] === selectedOpt1;
        });

        if (!matchingVariants.length) {
            matchingVariants = variants;
            selectedOpt1 = variants[0].options[0];
        }

        // Option 1 pills are ALWAYS fully enabled and visible
        $groups.eq(0).find('.variant-pill-label').show().removeClass('disabled is-unavailable');
        $groups.eq(0).find('.variant-pill-input').prop('disabled', false);

        // 3. For subsequent option groups (Option 2, Option 3), show ONLY the pills that exist under selected Option 1
        for (var i = 1; i < $groups.length; i++) {
            var $subGroup = $groups.eq(i);
            var validValuesForThisGroup = [];

            matchingVariants.forEach(function (v) {
                if (v.options[i] && validValuesForThisGroup.indexOf(v.options[i]) === -1) {
                    validValuesForThisGroup.push(v.options[i]);
                }
            });

            // Show pills that belong to this Option 1, HIDE the ones that belong to other option 1 choices
            $subGroup.find('.variant-pill-label').each(function () {
                var $label = $(this);
                var pillVal = $label.find('.variant-pill-input').val();
                if (validValuesForThisGroup.indexOf(pillVal) !== -1) {
                    $label.show().removeClass('disabled is-unavailable');
                    $label.find('.variant-pill-input').prop('disabled', false);
                } else {
                    $label.hide().addClass('disabled is-unavailable');
                    $label.find('.variant-pill-input').prop('disabled', true);
                }
            });

            // If the currently checked pill in this sub-group is now hidden/invalid, auto-select the first valid one
            var currentCheckedVal = $subGroup.find('.variant-pill-input:checked').val();
            if (validValuesForThisGroup.indexOf(currentCheckedVal) === -1 && validValuesForThisGroup.length > 0) {
                var newSelectedVal = validValuesForThisGroup[0];
                var $newInput = $subGroup.find('.variant-pill-input').filter(function () {
                    return $(this).val() === newSelectedVal;
                });
                $subGroup.find('.variant-pill-label').removeClass('active');
                $newInput.prop('checked', true);
                $newInput.closest('.variant-pill-label').addClass('active');
                $subGroup.find('.option-selected-value').html('<strong>' + newSelectedVal + '</strong>');
            }
        }

        // 4. Collect full selected options combination
        var currentSelections = [];
        $groups.each(function () {
            currentSelections.push($(this).find('.variant-pill-input:checked').val());
        });

        // 5. Find exact variant
        var exactVariant = variants.find(function (v) {
            return currentSelections.every(function (val, idx) {
                return !val || v.options[idx] === val;
            });
        });

        if (exactVariant) {
            $form.find('input[name="id"]').val(exactVariant.id);
            updateProductUI($form, exactVariant);
        } else {
            var $addBtn = $form.find('.add-to-cart-btn');
            $addBtn.prop('disabled', true).addClass('disabled');
            $form.find('.qty-control-pill').addClass('disabled');
            $form.find('.qty-control-pill .qty-btn, .qty-control-pill .qty-input').prop('disabled', true);
            if ($addBtn.find('.btn-text').length) {
                $addBtn.find('.btn-text').text('UNAVAILABLE');
            }
            $('.product-badge.badge-in-stock').hide();
        }
    }

    // Initialize variant availability on product forms
    $('form[action*="/cart/add"], #product-form').each(function () {
        var $form = $(this);
        var variantsJson = $form.find('[data-product-variants-json]').html();
        if (variantsJson) {
            try {
                var variants = JSON.parse(variantsJson);
                updateVariantAvailability($form, variants);
            } catch (e) {
                console.error("Error initializing product variants", e);
            }
        }
    });

    // Dynamic Product Variant Pill Selection
    $(document).on('change', '.variant-pill-input', function () {
        var $input = $(this);
        var $group = $input.closest('.variant-option-group');
        var $form = $input.closest('form');
        var selectedVal = $input.val();

        // Update pill active class
        $group.find('.variant-pill-label').removeClass('active');
        $input.closest('.variant-pill-label').addClass('active');

        // Update option header text
        $group.find('.option-selected-value').html('<strong>' + selectedVal + '</strong>');

        // Check availability and resolve matching variant
        var variantsJson = $form.find('[data-product-variants-json]').html();
        if (variantsJson) {
            try {
                var variants = JSON.parse(variantsJson);
                updateVariantAvailability($form, variants);
            } catch (e) {
                console.error("Error parsing product variants JSON", e);
            }
        }
    });

    // Support select dropdown if present
    $(document).on('change', 'select#product-select, select[name="id"]', function () {
        var $form = $(this).closest('form');
        var selectedVariantId = $(this).val();
        var variantsJson = $form.find('[data-product-variants-json]').html();
        if (variantsJson) {
            try {
                var variants = JSON.parse(variantsJson);
                var variant = variants.find(function (v) { return v.id == selectedVariantId; });
                if (variant) {
                    updateProductUI($form, variant);
                }
            } catch (e) {
                console.error("Error parsing product variants JSON", e);
            }
        }
    });

    // Prevent submission if product variant is sold out, unavailable, or required custom options missing
    $(document).on('submit', '#product-form, form[action*="/cart/add"]', function (e) {
        var $btn = $(this).find('.add-to-cart-btn');
        if ($btn.is(':disabled') || $btn.hasClass('disabled') || $btn.prop('disabled') || $btn.hasClass('btn-choose-options')) {
            e.preventDefault();
            return false;
        }

        // Validate custom terms agreement checkbox if present
        var $terms = $(this).find('#customTermsCheckbox');
        if ($terms.length && $terms.is(':visible') && !$terms.is(':checked')) {
            e.preventDefault();
            alert('Please agree to the custom made product terms of purchase before adding to cart.');
            $terms.focus();
            return false;
        }
    });

    // Function to ensure terms checkbox is always directly above Quantity & Choose Options
    function ensureTermsPosition() {
        var $terms = $('#customTermsWrap');
        var $actionSec = $('.product-action-sec');
        if ($terms.length && $actionSec.length) {
            // Unconditionally place directly before .product-action-sec (above Quantity)
            $actionSec.before($terms);
        }
    }

    // Custom-Made Products: Terms Checkbox and Options Change Listeners
    $(document).on('change', '#customTermsCheckbox', function () {
        var $form = $(this).closest('form');
        validateCustomProductState($form);
    });

    $(document).on('change', '.hulkapps-custom-options select, .hulkapps_option select, select.hulkapps_option_child, .hulkapps-custom-options input', function () {
        var $form = $(this).closest('form');
        ensureTermsPosition();
        if ($form.hasClass('is-custom-made')) {
            validateCustomProductState($form);
        }
    });

    // Detect if Hulk Options asynchronously injected into the product form
    function checkHulkOptionsLoaded() {
        var $hulk = $('.hulkapps-custom-options, .hulkapps_option');
        if ($hulk.length && ($hulk.children().length > 0 || $hulk.find('select, input').length > 0)) {
            var $form = $('#product-form');
            ensureTermsPosition();
            if ($form.hasClass('is-custom-made')) {
                validateCustomProductState($form);
            }
        }
    }

    var hulkCheckCount = 0;
    var hulkCheckTimer = setInterval(function () {
        checkHulkOptionsLoaded();
        hulkCheckCount++;
        if (hulkCheckCount > 15) clearInterval(hulkCheckTimer);
    }, 300);

    // Initial validation check & positioning for custom products
    ensureTermsPosition();
    if ($('#customTermsCheckbox').length && $('#product-form').hasClass('is-custom-made')) {
        validateCustomProductState($('#product-form'));
    }

    // AJAX Add to Cart for Pairs Well With items
    $(document).on('click', '.pairs-add-cart-btn', function (e) {
        e.preventDefault();
        var $btn = $(this);
        if ($btn.is(':disabled') || $btn.prop('disabled') || $btn.hasClass('disabled')) {
            return false;
        }
        var variantId = $btn.data('variant-id');
        if (!variantId) {
            var href = $btn.closest('.pairs-well-box').find('a').attr('href');
            if (href) window.location.href = href;
            return;
        }

        var originalText = $btn.text();
        $btn.text('ADDING...').prop('disabled', true);

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: variantId, quantity: 1 },
            dataType: 'json',
            success: function () {
                $btn.text('ADDED!').addClass('added');
                setTimeout(function () {
                    $btn.text(originalText).prop('disabled', false).removeClass('added');
                }, 2000);
                $(document).trigger('cart:updated');
            },
            error: function () {
                $btn.text('ERROR').prop('disabled', false);
                setTimeout(function () {
                    $btn.text(originalText);
                }, 2000);
            }
        });
    });

    /* ============================================================
       Search Autocomplete, Recent Searches & Trending Products
       ============================================================ */
    function initPredictiveSearch() {
        var $searchInput = $('#headerSearchInput');
        var $dropdown = $('#searchDropdownWrapper');
        var $initialView = $('#searchDropdownInitial');
        var $resultsView = $('#searchDropdownResults');
        var $noResultsView = $('#searchDropdownNoResults');
        var $loadingView = $('#searchDropdownLoading');
        var $resultsList = $('#searchResultsList');
        var $viewAllBtn = $('#searchViewAllBtn');
        var $recentSection = $('#searchRecentSection');
        var $recentList = $('#searchRecentList');
        var $noResultsQuery = $('#searchNoResultsQuery');

        if (!$searchInput.length || !$dropdown.length) return;

        var searchTimeout = null;
        var RECENT_SEARCHES_KEY = 'klm_recent_searches';

        function getRecentSearches() {
            try {
                var stored = localStorage.getItem(RECENT_SEARCHES_KEY);
                return stored ? JSON.parse(stored) : [];
            } catch (e) {
                return [];
            }
        }

        function saveRecentSearch(term) {
            if (!term || typeof term !== 'string') return;
            var cleanTerm = term.trim();
            if (!cleanTerm) return;

            var searches = getRecentSearches();
            searches = searches.filter(function (item) {
                return item.toLowerCase() !== cleanTerm.toLowerCase();
            });
            searches.unshift(cleanTerm);
            if (searches.length > 6) {
                searches = searches.slice(0, 6);
            }

            try {
                localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
            } catch (e) { }
        }

        function renderRecentSearches() {
            var searches = getRecentSearches();
            if (searches && searches.length > 0) {
                var html = '';
                searches.forEach(function (term) {
                    var encoded = encodeURIComponent(term);
                    html += '<li><a href="/search?type=product&q=' + encoded + '" class="search-term-link" data-search-term="' + $('<div>').text(term).html() + '">' + $('<div>').text(term).html() + '</a></li>';
                });
                $recentList.html(html);
                $recentSection.show();
            } else {
                $recentSection.hide();
            }
        }

        function showInitialView() {
            renderRecentSearches();
            $dropdown.removeClass('has-no-results');
            $resultsView.hide();
            $noResultsView.hide();
            $loadingView.hide();
            $initialView.show();
            $dropdown.show();
        }

        function formatPrice(val) {
            if (val === undefined || val === null || val === '') return '';
            if (typeof val === 'string' && val.indexOf('$') !== -1) return val;
            var num = parseFloat(val);
            if (isNaN(num)) return val;
            if (num > 1000 && String(val).indexOf('.') === -1) {
                num = num / 100;
            }
            return '$' + num.toFixed(2);
        }

        function performSearch(query) {
            if (!query) {
                showInitialView();
                return;
            }

            $initialView.hide();
            $resultsView.hide();
            $noResultsView.hide();
            $loadingView.show();
            $dropdown.show();

            $.ajax({
                url: '/search/suggest.json',
                type: 'GET',
                data: {
                    q: query,
                    'resources[type]': 'product',
                    'resources[options][unavailable_products]': 'hide',
                    'resources[options][fields]': 'title,product_type,variants.title,vendor'
                },
                dataType: 'json',
                success: function (response) {
                    $loadingView.hide();
                    var products = (response.resources && response.resources.results && response.resources.results.products) ? response.resources.results.products : [];

                    if (products.length > 0) {
                        $dropdown.removeClass('has-no-results');
                        var html = '';
                        products.slice(0, 6).forEach(function (prod) {
                            var img = prod.featured_image ? (prod.featured_image.url || prod.featured_image) : (prod.image || '');
                            if (!img) img = 'https://cdn.shopify.com/s/files/1/0000/0000/t/1/assets/productmainimg.png';

                            var priceText = formatPrice(prod.price);
                            var comparePriceText = (prod.compare_at_price && parseFloat(prod.compare_at_price) > parseFloat(prod.price)) ? formatPrice(prod.compare_at_price) : '';

                            html += '<a href="' + prod.url + '" class="search-result-item" data-search-term="' + $('<div>').text(prod.title).html() + '">';
                            html += '  <img src="' + img + '" alt="' + $('<div>').text(prod.title).html() + '" class="search-result-img">';
                            html += '  <div class="search-result-info">';
                            html += '    <h4 class="search-result-title">' + prod.title + '</h4>';
                            html += '    <div class="search-result-meta">';
                            if (prod.vendor) {
                                html += '      <span class="search-result-vendor">' + prod.vendor + '</span>';
                            }
                            if (priceText) {
                                html += '      <span class="search-result-price">' + priceText + '</span>';
                            }
                            if (comparePriceText) {
                                html += '      <del class="search-result-old-price">' + comparePriceText + '</del>';
                            }
                            html += '    </div>';
                            html += '  </div>';
                            html += '</a>';
                        });

                        $resultsList.html(html);
                        $viewAllBtn.attr('href', '/search?type=product&q=' + encodeURIComponent(query));
                        $viewAllBtn.text('View all results for "' + query + '"');
                        $resultsView.show();
                    } else {
                        // 0 Results: show 2-column trending & popular searches
                        $dropdown.addClass('has-no-results');
                        $noResultsQuery.text(query);
                        $noResultsView.show();
                    }
                },
                error: function () {
                    $loadingView.hide();
                    $dropdown.addClass('has-no-results');
                    $noResultsQuery.text(query);
                    $noResultsView.show();
                }
            });
        }

        // Event: Focus & Click on input
        $searchInput.on('focus click', function () {
            var val = $(this).val().trim();
            if (!val) {
                showInitialView();
            } else {
                performSearch(val);
            }
        });

        // Event: Typing in input (debounced)
        $searchInput.on('input', function () {
            var query = $(this).val().trim();
            clearTimeout(searchTimeout);
            if (!query) {
                showInitialView();
            } else {
                searchTimeout = setTimeout(function () {
                    performSearch(query);
                }, 250);
            }
        });

        // Event: Click on search term link or search result item
        $(document).on('click', '.search-term-link, .search-result-item, .trending-product-card', function () {
            var term = $(this).data('search-term') || $(this).text();
            if (term) saveRecentSearch(term);
        });

        // Event: Search form submit
        $('.search-sec').on('submit', function () {
            var query = $(this).find('input[name="q"]').val();
            if (query) saveRecentSearch(query);
        });

        // Event: Close dropdown when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.search-sec').length) {
                $dropdown.hide();
            }
        });
    }

    initPredictiveSearch();
});
/* 15.9.26 end */